import { useEffect } from "react";
import { IoChevronForward } from "react-icons/io5";
import AOS from "aos";
import "aos/dist/aos.css";

const LogisticsContent = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      offset: 200,
    });
  }, []);
  return (
    <div className="bg-nightSoft">
      <div className="max-w-[1140px] mx-auto p-4 pt-20">
        <div>
          <h1 className="text-3xl font-bold text-white">
            Why Invest in{" "}
            <span className="text-gradient">Logistics & Transport Solutions?</span>
          </h1>
          <div
            data-aos="fade-right"
            className="web3-underline w-[60px] mt-3"
          ></div>
        </div>
        <div>
          <div className="flex py-5">
            <IoChevronForward className="text-customRed w-[60px]" size={30} />
            <p className="text-gray-400">
              Modern logistics technology dramatically reduces operational
              costs. Route optimization alone can cut fuel consumption and
              delivery times significantly, while automated dispatching
              eliminates manual planning errors. Businesses that digitize their
              logistics operations consistently outperform competitors who
              still rely on spreadsheets and phone calls to manage their
              fleets.
            </p>
          </div>
          <div className="flex py-2">
            <IoChevronForward className="text-customRed w-[60px]" size={30} />
            <p className="text-gray-400">
              Real-time visibility builds customer trust. Today's customers
              expect to know exactly where their shipment is and when it will
              arrive. With live GPS tracking, automated notifications, and
              accurate ETAs, you keep customers informed at every stage of the
              delivery journey, reducing support calls and increasing repeat
              business.
            </p>
          </div>
          <div className="flex py-2">
            <IoChevronForward className="text-customRed w-[60px]" size={30} />
            <p className="text-gray-400">
              Data-driven decisions transform your supply chain. By collecting
              and analyzing data from every vehicle, warehouse, and shipment,
              you gain insights into bottlenecks, demand patterns, and
              underutilized assets. This intelligence allows you to forecast
              demand, plan capacity, and continuously improve your operations.
            </p>
          </div>
          <div className="flex py-2">
            <IoChevronForward className="text-customRed w-[40px]" size={30} />
            <p className="text-gray-400">
              Fleet management systems extend vehicle lifespans and improve
              driver safety. Preventive maintenance scheduling, driver behavior
              monitoring, and fuel management help you protect your most
              expensive assets while reducing accidents and downtime.
            </p>
          </div>
          <div className="flex py-2">
            <IoChevronForward className="text-customRed w-[60px]" size={30} />
            <p className="text-gray-400">
              Scalability becomes effortless with the right digital
              infrastructure. Whether you operate ten vehicles or ten thousand,
              a well-architected logistics platform grows with your business.
              Integrations with e-commerce platforms, ERPs, and third-party
              carriers mean you can expand into new markets and services
              without rebuilding your operations from scratch.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogisticsContent;
